import React from "react";
import AdmissionNotice from "./AdmissionNotice";
import AdmissionImage from "./AdmissionImage";

const AdmissionSection = () => {
  return (
    <div
      className="gdlr-core-pbf-wrapper background-wrapper"
      style={{ padding: "65px 0px 0px 0px" }}
    >
      <div
        className="gdlr-core-pbf-background-wrap"
        style={{ backgroundColor: "#7c1c1bd9" }}
      ></div>
      <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <AdmissionNotice />
          <AdmissionImage />
        </div>
      </div>
    </div>
  );
};

export default AdmissionSection;
